export default "__VITE_ASSET__BAXcy4uK__"